// extracted by mini-css-extract-plugin
export var component = "SearchHits-module--component--eerxr";
export var excerpt = "SearchHits-module--excerpt--jFbEq";
export var isCompact = "SearchHits-module--isCompact--ZGPJC";
export var list = "SearchHits-module--list--We-wB";
export var mediaWrapper = "SearchHits-module--mediaWrapper--d+Pby";
export var wrapper = "SearchHits-module--wrapper--0lh3I";